import React from 'react';
import './styles.scss';
import { Textlink } from '../Button';

interface HeadlineTextTextlinkTileProps {
    headline: string;
    subline: string;
    className?: string;
    textlink1: { text: string; svg: string; onClick: () => void };
    textlink2: { text: string; svg: string; onClick: () => void };
}

export default function HeadlineTextTextlinkTile({
    headline,
    subline,
    className,
    textlink1,
    textlink2,
}: HeadlineTextTextlinkTileProps): JSX.Element {

    return (
        <article className={`headline-text-textlink-tile ${className}`}>
            <h3>{headline}</h3>
            <p className='body large'>{subline}</p>
            <Textlink
                type='svg-left'
                color='dark-blue'
                text={textlink1.text}
                svg={textlink1.svg}
                onClick={textlink1.onClick}
            />
            <Textlink
                type='svg-left'
                color='dark-blue'
                text={textlink2.text}
                svg={textlink2.svg}
                onClick={textlink2.onClick}
            />
        </article>
    );
}
